import { Box, Button, Typography } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  getMultiBookingList,
  resetMultiBookingListData,
} from "../new-booking-form/new-booking-form.slice";

const MultiBookingThankYou = () => {
  const [countdown, setCountdown] = useState(15);
  const { applicantData, multiBookingListData } = useSelector(
    (state) => state?.newBookingForm
  );
  const isAllFormsFilled = multiBookingListData?.isAllFormsFilled;
  const groupId = useMemo(
    () => applicantData?.groupId,
    [applicantData?.groupId]
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();

  useEffect(() => {
    if (groupId) {
      dispatch(getMultiBookingList({ groupId }));
    }
    return () => {
      dispatch(resetMultiBookingListData());
    };
  }, [dispatch, groupId]);

  const handleViewAllBookings = () => {
    history.push(`/group-listing/${groupId}`);
  };

  const handleProceedToMap = useCallback(() => {
    history.push(`/applicant-mapping/${groupId}`);
  }, [history, groupId]);

  useEffect(() => {
    let timer;
    if (!isAllFormsFilled) {
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            handleProceedToMap();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [handleProceedToMap, isAllFormsFilled]);

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#1C252E",
          mt: 3,
        }}
      >
        {t("multiBookingThankYou.title")},{" "}
        <Box component="span" sx={{ fontWeight: 700 }}>
          {applicantData?.applicant1?.personalDetails?.firstName}{" "}
          {applicantData?.applicant1?.personalDetails?.lastName}
        </Box>
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontSize: "16px",
          fontWeight: 400,
          color: "#1C252E",
        }}
      >
        {t("multiBookingThankYou.submittedSuccessfully")}
      </Typography>
      {!isAllFormsFilled && (
        <>
          <Typography
            variant="body2"
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              color: "#1C252E",
            }}
          >
            {t("multiBookingThankYou.redirectMsg", {
              projectName: applicantData?.unitDetails?.projectName,
              unitNo: applicantData?.unitDetails?.unitNo,
            })}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "16px",
              fontWeight: 400,
              color: "#1C252E",
            }}
          >
            {t("multiBookingThankYou.secondsTimer", {
              countdown: countdown,
            })}
          </Typography>
        </>
      )}
      <Box
        display="flex"
        gap="16px"
        justifyContent="center"
        flexWrap="wrap"
        width="100%"
        mt={2}
      >
        <Button
          variant="outlined"
          sx={{
            border: "1px solid #D0D5DD",
            color: "#1A407D",
            fontSize: "16px",
            fontWeight: 600,
            padding: "12px 20px",
            borderRadius: "8px",
            width: "249px",
            textTransform: "none",
            "&:hover": {
              borderColor: "#D0D5DD",
            },
          }}
          onClick={handleViewAllBookings}
        >
          {t("multiBookingThankYou.buttons.viewAllBookings")}
        </Button>
        {!isAllFormsFilled && (
          <Button
            variant="contained"
            sx={{
              color: "#FFFFFF",
              fontSize: "16px",
              fontWeight: 600,
              width: "259",
              padding: "12px 20px",
              backgroundColor: "#1A407D",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#0d2c5eff",
              },
            }}
            onClick={handleProceedToMap}
          >
            {t("multiBookingThankYou.buttons.proceedToMap")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default MultiBookingThankYou;
